import { Image, Layers3, MousePointer2, Plus, Ruler, Send } from 'lucide-react';

export type DockTool = 'table' | 'element' | 'background' | 'add' | 'layers' | 'finish';

const tools = [
  { id: 'table', label: 'Mesa', icon: Ruler },
  { id: 'background', label: 'Fondo', icon: Image },
  { id: 'add', label: 'Agregar', icon: Plus },
  { id: 'element', label: 'Elemento', icon: MousePointer2 },
  { id: 'layers', label: 'Capas', icon: Layers3 },
  { id: 'finish', label: 'Finalizar', icon: Send },
] as const;

interface ToolDockProps {
  readonly active: DockTool | null;
  readonly onSelect: (tool: DockTool) => void;
}

export function ToolDock({ active, onSelect }: ToolDockProps) {
  return (
    <nav className="tool-dock" aria-label="Herramientas del editor">
      {tools.map(({ id, label, icon: Icon }) => (
        <button
          key={id}
          type="button"
          className={active === id ? 'is-active' : ''}
          aria-current={active === id ? 'true' : undefined}
          onClick={() => onSelect(id)}
        >
          <Icon aria-hidden="true" size={22} strokeWidth={1.8} />
          <span>{label}</span>
        </button>
      ))}
    </nav>
  );
}
